import colors from '../../../../../public/colors'
 

const styles = theme => {
    const { mode } = theme.palette
    return {
        actionRow: {
            '& > button': {
                marginLeft: 'auto'
            },
            justifyContent: 'flex-end',
            height: '100%',
            padding: '16px 24px'
        },
        authenticatorCodeBox: {
            alignItems: 'flex-start',
            display: 'inline-flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        authenticatorCodeContainer: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: '0px',
            marginTop: '0px',
            padding: '48px 24px',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                padding: '32px 16px',
            }
        },
        button: {
            '&.MuiButton-root': {
                border: '1px solid #006AC3',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                height: '40px',
                marginLeft: '10px',
                width: '104px'
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)'
            }
        },
        buttonContainer: {
            '@media screen and (max-width: 320px)': {
                paddingBottom: '20px',
                paddingTop: '24px'
            },
            backgroundColor: colors[mode].primaryBackground,
        },
        buttonBack: {
            '&.MuiButton-root': {
                border: `1px solid ${colors[mode].primaryText}`,
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: colors[mode].primaryText,
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                padding: '8px 16px',
                textTransform: 'uppercase',
                width: 'auto',
            },
            '&:disabled': {
                opacity: '0.5'
            }
        },
        buttonSubmit: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                border: '1px solid #FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                padding: '8px 16px',
                textTransform: 'uppercase',
                width: 'auto'
            },
            '&:disabled': {
                opacity: '0.5'
            }
        },
        content: {
            fontSize: '24px',
            fontWeight: '500'
        },
        contentContainer: {
            borderRadius: '3px',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        },
        contentDivider: {
            paddingTop: '25px'
        },
        contentSection: {
            fontSize: '20px'
        },
        divider: {
            background: '#FFC72A',
            padding: '2px',
            width: '50px'
        },
        errorContainer: {
            alignItems: 'center',
            display: 'inline-flex',
            justifyContent: 'center',
            marginTop: '16px',
        },
        errorText: {
            marginLeft: '4px'
        },
        fieldsContainer: {
            alignItems: 'center',
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            minHeight: '275px',
            width: '100%'
        },
        formContainer: {
            backgroundColor: colors[mode].primaryBackground,
            flexDirection: 'column',
            minHeight: '275px',
        },
        otpInput: {
            color: colors[mode].primaryText,
            width: '30px',
            height: '40px',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: '400',
            border: 'none',
            borderBottom: `2px solid ${colors[mode].secondaryText}`,
            borderRadius: '0',
            outline: 'none',
            background: 'transparent',
            letterSpacing: '0.15px',
            lineHeight: '20px',
            transition: 'border-color 0.2s',
            '&:focus': {
                borderBottomColor: '#006AC3',
                borderBottomWidth: '2px'
            },
            '&:hover': {
                borderBottomColor: '#006AC3)'
            }
        },
        otpInputError: {
            '&&': {
                borderBottomColor: '#d32f2f',
                borderBottomWidth: '2px'
            },
        },
        otpInputFilled: {
            borderBottomColor: '#006AC3',
            borderBottomWidth: '2px'
        },
        otpInputVerified: {
            '&&': {
                borderBottomColor: colors[mode].successTextLight,
                color: colors[mode].successTextLight,
                borderBottomWidth: '2px'
            }
        },
        otpLabel: {
            color: colors[mode].secondaryText,
            fontSize: '12px',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '12px',
            letterSpacing: '0.15px',
            marginBottom: '8px',
        },
        show: {
            display: 'block'
        },
        hide: {
            display: 'none'
        },
        loader: {
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%',
            'z-index': '10'
        },
        root: {
            padding: theme.spacing(0, 2, 2, 2)
        }, 
        italics: {
            fontStyle: 'italic'
        },
        successContainer: {
            '@media screen and (max-width: 1350px)': {
                padding: '0px 20px'
            },
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: theme.spacing(2),
            marginTop: '16px',
        },
        successMsg: {
            color: theme.palette.success.main,
            display: 'flex',
            fontSize: '14px',
            justifyContent: 'center',
        },
        warningLine: {
            background: colors[mode].primaryBackground,
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            padding: '0px 0px 24px 32px'
        }
    }
}
export default styles
